"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConstantResolver = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ConstantReference = require("./ConstantReference");
class ConstantResolver {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "const");
  }
  resolve(context, param) {
    let value = new _ConstantReference.ConstantReference(param);
    return {
      value: value.value()
    };
  }
  resolveReference(context, param) {
    let value = new _ConstantReference.ConstantReference(param);
    return {
      path: undefined,
      value
    };
  }
}
exports.ConstantResolver = ConstantResolver;
//# sourceMappingURL=ConstantResolver.js.map